import React from 'react';
import { motion } from 'framer-motion';
import { Shield } from 'lucide-react';
export function Guarantee() {
  return <section className="w-full bg-cream-bg py-20 px-4" data-id="element-105">
      <div className="max-w-3xl mx-auto" data-id="element-106">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-white rounded-2xl shadow-xl p-8 md:p-12 border-2 border-green-200" data-id="element-107">
          <div className="flex flex-col items-center text-center" data-id="element-108">
            <div className="w-20 h-20 bg-green-100 rounded-full flex items-center justify-center mb-6" data-id="element-109">
              <Shield className="w-10 h-10 text-green-600" data-id="element-110" />
            </div>

            <h2 className="text-3xl md:text-4xl font-display font-bold text-navy-primary mb-6" data-id="element-111">
              🛡️ รับประกันคืนเงิน 100% ภายใน 7 วัน
            </h2>

            <div className="space-y-4 text-lg text-gray-700 max-w-2xl" data-id="element-112">
              <p data-id="element-113">ดาวน์โหลดทั้งหมด อ่านทั้งหมด</p>
              <p data-id="element-114">นำไปใช้ในคลาสของคุณ</p>
              <p className="font-bold text-navy-primary" data-id="element-115">
                ถ้าคุณไม่พอใจ 100% ภายใน 7 วัน
                <br data-id="element-116" />
                เราคืนเงินทุกบาท
              </p>
              <p className="text-base text-gray-600 mt-6" data-id="element-117">
                ไม่มีคำถาม ไม่มีขั้นตอนยุ่งยาก
                <br data-id="element-118" />
                ความเสี่ยงทั้งหมดเป็นของเราทั้งหมด
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}